import React, { useEffect, useState } from "react";

import "../../../style/dashboard-saas.module.css";
import "../../../style/dashboard/billing.module.css";
import "../../../style/license-key-modal.module.css";
import { getStripePortalSession } from "../../../api/user/billing/portal/get";
import InlineNotification from "../../../components/elements/Notification";
import { useHistory } from "react-router-dom";

export default function SaasBilling() {
    const navigate = useHistory();
    const [stripePortalSessionResponse, setStripePortalSessionResponse] = useState<
        { stripePortalLink: string | null; paymentInfoShared: boolean } | undefined
    >(undefined);

    const [isFetchingStripePortalSessionError, setIsFetchingStripePortalSessionError] = useState(false);
    const [isFetchingStripePortalSessionLink, setIsFetchingStripePortalSessionLink] = useState(false);

    async function getStripePortalLink() {
        setIsFetchingStripePortalSessionLink(true);
        setIsFetchingStripePortalSessionError(false);
        try {
            const res = await getStripePortalSession({
                returnURL: `${window.location.origin}${window.location.pathname}`
            });

            if (res.stripePortalLink === null) {
                navigate.push("/dashboard-saas");
            }

            setStripePortalSessionResponse(res);
        } catch (_) {
            setIsFetchingStripePortalSessionError(true);
        } finally {
            setIsFetchingStripePortalSessionLink(false);
        }
    }
    function renderPaymentsSection() {
        if (isFetchingStripePortalSessionLink) {
            return (
                <div className="padding-28" style={{ position: "relative", minHeight: "300px" }}>
                    <div className="center">
                        <img className="loader" src="/static/assets/dashboard/loading.svg" alt="loading" />
                    </div>
                </div>
            );
        }

        const stripePortalLink = stripePortalSessionResponse?.stripePortalLink

        return (
            <div>
                <div className="padding-28">
                    <div className="info-blue-container margin-top-0">
                        <span className="info-blue-pill">Note</span>
                        <p>
                            {" "}
                            All billing related information, including invoices and receipts, is managed by Stripe. You
                            can update your card and payment information on Stripe customer portal.
                        </p>
                    </div>
                </div>
                <hr />
                {!isFetchingStripePortalSessionError && stripePortalLink !== null ? (
                    <div className="padding-28">
                        {stripePortalSessionResponse?.paymentInfoShared === false ? (
                            <button
                                onClick={() => window.open(stripePortalLink, "_self")}
                                className="btn btn-sm white-button"
                                style={{ fontSize: 14, marginRight: "12px" }}
                            >
                                <img
                                    src="/static/assets/dashboard/plus-gray.svg"
                                    style={{ height: "14px", width: "14px", marginRight: "6px" }}
                                    alt="plus icon"
                                />
                                Add Payment Info
                            </button>
                        ) : null}
                        <button
                            onClick={() => window.open(stripePortalLink, "_self")}
                            className="btn btn-sm yellow-button"
                        >
                            Manage Billing
                        </button>
                    </div>
                ) : null}
                {isFetchingStripePortalSessionError || stripePortalSessionResponse === undefined ? (
                    <div style={{ width: "fit-content", paddingTop: 28 }} className="padding-28">
                        <InlineNotification size="sm" status="error">
                            Failed to fetch you payment details.{" "}
                            <span onClick={getStripePortalLink} className="highlight">
                                Please try again!
                            </span>
                        </InlineNotification>
                    </div>
                ) : null}
            </div>
        );
    }

    useEffect(() => {
        getStripePortalLink();
    }, []);

    return (
        <div className="saas-container">
            <div className="billing-container">
                <div className="centered-box">
                    <div className="centered-box paper">
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <h4 className="app-name-heading padding-28">Billing Info</h4>
                        </div>
                        <hr />
                        {renderPaymentsSection()}
                    </div>
                </div>
            </div>
        </div>
    );
}
